import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent, useCallback, useEffect, useRef } from 'react';
import { RegisterOptions, useController } from 'react-hook-form';
import { useAdmin } from '../../contexts/admin.context';

type FormTextFieldProps = TextFieldProps & {
  name: string;
  canBeNegative?: boolean;
  required?: boolean;
  rules?: RegisterOptions;
};

function handleWheel(event: WheelEvent) {
  event.preventDefault();
}

const FormPriceField: React.FC<FormTextFieldProps> = ({ name, sx, rules, required, canBeNegative, ...rest }) => {
  const { field } = useController({ name, rules });
  const { cafe } = useAdmin();

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      if (value === '') {
        field.onChange(0);
      }
      const patern = canBeNegative ? /^-?\d+(\.\d{0,2})?$/ : /^\d+(\.\d{0,2})?$/;
      if (patern.test(value)) {
        field.onChange(Number(value) * 100);
      }
    },
    [canBeNegative, field]
  );

  useEffect(() => {
    const input = inputRef.current;
    if (input) {
      input.addEventListener('wheel', handleWheel, { passive: false });
    }
    return () => {
      input?.removeEventListener('wheel', handleWheel);
    };
  }, [inputRef]);

  return (
    <TextField
      required={Boolean(required)}
      type="number"
      color="info"
      InputProps={{ ref: inputRef, endAdornment: cafe?.currency }}
      {...field}
      onChange={handleChange}
      value={field.value ? Number(field.value) / 100 : ''}
      {...rest}
      sx={{
        div: {
          backgroundColor: (t) => t.palette.background.paper,
        },
        ...sx,
      }}
    />
  );
};

export default FormPriceField;
